import Swal from 'sweetalert2';
import Params from './getParams';
import { userRegisterCourse, getStudents } from './api';

const COURSE_BOOKING_CLOSED_MESSAGE = '此課程已超過預約截止時間，最晚需於課程日前一天預約。';



//選擇學生登記
const registerModal = async (data,calendar,el) => {

  const html = renderCheckboxHtml(data)
  const { value: values } = await Swal.fire({
    title: '學生：',
    html: html,
    focusConfirm: false,
    preConfirm: () => {
      var checkedValue = [];
      var inputElements = document.getElementsByClassName('student');
      for(var i=0; inputElements[i]; ++i){
            if(inputElements[i].checked){
                checkedValue.push(inputElements[i].value);
            }
      }
      return checkedValue
    }
  })

  if (values) {
    const lineId = Params.lineId;
    const courseId = el.extendedProps.courseId;

      userRegisterCourse({
        lineId: lineId,
        student_ids: values,
        course_id: courseId,
        staff_booking: Params.staffBooking,
      })
        .then(function (response) {

          const msg =  response.data.message
          Swal.fire( '登記成功', msg, 'success');
        })
        .catch(function (error) {
          let errorMsg = error.response.data.message;
          if (values.length === 0) {
            errorMsg += '請選擇學生再送出'
          }
          Swal.fire('登記失敗', '', 'error');
          Swal.showValidationMessage(`${errorMsg}`);
          console.log(error);
        })
        .then(function () {
          calendar.refetchEvents();

          getStudents().then(function (response) {
            const data = response.data
            const span = document.getElementById('qNum')
            span.innerHTML = Params.isGym ? data.gymQuota : data.functionQuota;
          })
        })
    // Swal.fire({ html: `${msg}` })
  }

}

//登記課程
function courseModal(calendar, el) {

  if (!Params.staffBooking && moment(el.start).format('YYYY-MM-DD') <= moment().format('YYYY-MM-DD')) {
    Swal.fire({
      title: '無法預約',
      text: COURSE_BOOKING_CLOSED_MESSAGE,
      icon: 'warning',
      confirmButtonText: '知道了'
    });
    return;
  }

  Swal.fire({
    title: `<strong> ${el.title} </strong>`,
    icon: false,
    customClass: 'swal-course',
    html: modalHtmlTemplate(el),
    showCloseButton: true,
    showCancelButton: false,
    focusConfirm: false,
    confirmButtonText: '登記課程',
    confirmButtonAriaLabel: '登記課程',
    preConfirm: (event) => {
      getStudents().then(function (response) {
        registerModal(response.data, calendar, el)
      })
    },
  })
}

function courseAdminModal(calendar, el) {

  Swal.fire({
    title: `<strong> ${el.title} </strong>`,
    icon: false,
    customClass: 'swal-course',
    html: modalHtmlTemplate(el),
    showCloseButton: true,
    showCancelButton: false,
    focusConfirm: false,
    confirmButtonText: '詳細資料',
    confirmButtonAriaLabel: '詳細資料',
    preConfirm: (event) => {
      const courseId = el.extendedProps.courseId;
      window.open(`${process.env.host}/courses/${courseId}`, '_blank');
    },
  }).then((result) => {
    // if (result.isConfirmed) {
    //    console.log('測試');
    // }
  });
}

function renderCheckboxHtml(data){
   let html = ''
      data.students.forEach((element,i) => {
        html += `<div class="input-wrap"><input type="checkbox" id="swal-input${i+1}" class="swal2-checkbox student" name="students[]"  value="${element.id}">
     <label for="swal-input${i+1}">${element.name}</label> </div>`
  });
  return '<div class="input-outerwrap">' + html + '</div>'
}

function modalHtmlTemplate (el){
  const timeRange = `${moment(el.start).format('HH:mm')}`;

  const html = `<table class="table">
                <tbody>
                  <tr>
                    <th scope="row">上課時間</th>
                    <td>${timeRange}</td>
                  </tr>
                  <tr>
                    <th scope="row">老師姓名</th>
                    <td>${el.extendedProps.teacher}</td>
                  </tr>
                  <tr>
                    <th scope="row">基本收費</th>
                    <td>${el.extendedProps.fee}</td>
                  </tr>
                  <tr>
                    <th scope="row">學生人數上限</th>
                    <td>${el.extendedProps.studentLimit}</td>
                  </tr>
                  <tr>
                    <th scope="row">課程長度(小時)</th>
                    <td>${el.extendedProps.courseDuration}</td>
                  </tr>
                </tbody>
              </table>
              <p>課程介紹</p>
              <p>${el.extendedProps.intro}</p>`
 return html
}

const showError = Swal.mixin({
  icon: 'warning',
  showConfirmButton: false,
  timer: 1800
})

window.showError = showError;

const sweet = { courseModal: courseModal,
                courseAdminModal: courseAdminModal,
               };

export { sweet as Sweet };
